import React, { useState } from 'react';
import { createMissingAutomations } from '../../services/AutomationsService';
import { processError } from '../../services/ServiceUtils';

function CompletarAutomacoesButton({ onSuccess }) {
    const [open, setOpen] = useState(false);
    const [symbol, setSymbol] = useState('BTCUSDT');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState('');

    async function handleCreate() {
        const sym = symbol.trim().toUpperCase();
        setLoading(true);
        setResult(null);
        setError('');
        try {
            const res = await createMissingAutomations(sym);
            setResult(res);
            if (res.created > 0 && onSuccess) onSuccess();
        } catch (err) {
            setError(processError(err) || 'Erro ao criar automações.');
        } finally {
            setLoading(false);
        }
    }

    if (!open) {
        return (
            <button className='btn btn-outline-secondary animate-up-2 me-2' onClick={() => setOpen(true)}>
                Completar essenciais
            </button>
        );
    }

    return (
        <div className='d-inline-flex align-items-center gap-2 me-2'>
            <input
                className='form-control form-control-sm'
                style={{ width: 120 }}
                value={symbol}
                onChange={e => { setSymbol(e.target.value); setResult(null); setError(''); }}
                placeholder='Símbolo'
            />
            <button className='btn btn-sm btn-primary' onClick={handleCreate} disabled={loading}>
                {loading ? '...' : 'Criar'}
            </button>
            <button className='btn btn-sm btn-outline-secondary' onClick={() => { setOpen(false); setResult(null); setError(''); }}>
                ✕
            </button>
            {result !== null && (
                <span className={`small ${result.created > 0 ? 'text-success' : 'text-muted'}`}>
                    {result.created > 0
                        ? `${result.created} automação(ões) criada(s): ${result.items.map(i => i.name).join(', ')}`
                        : 'Automações essenciais já existem.'}
                </span>
            )}
            {error && <span className='small text-danger'>{error}</span>}
        </div>
    );
}

export default CompletarAutomacoesButton;
